module.exports = __webpack_public_path__ + "572f66865dcb7d006c65c3dbb054d3f3.png";